import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { to: '/', label: '首页' },
      { to: '/categories', label: '分类导航' },
      { to: '/about', label: '关于我们' },
    ],
  },
  {
    title: '使用指南',
    links: [
      { to: '/article/jm-comic-register-guide', label: '注册教程' },
      { to: '/article/jm-comic-vip-benefits', label: '会员权益' },
      { to: '/article/jm-comic-download-guide', label: '下载指南' },
      { to: '/article/jm-comic-reading-settings', label: '阅读设置' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { to: '/article/jm-comic-security-tips', label: '安全指南' },
      { to: '/article/jm-comic-payment-guide', label: '支付教程' },
      { to: '/about', label: '联系我们' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                JM Comic
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              JM Comic 是广受欢迎的漫画阅读平台，提供海量正版与同人漫画资源，为漫画爱好者提供优质的阅读体验。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {new Date().getFullYear()} JM Comic. 保留所有权利。
          </p>
          <div className="flex items-center gap-4 text-sm text-background-50/40">
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="hover:text-background-50/70 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}